module.exports = __webpack_public_path__ + "img/824a0a5.png";